var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectLangIcon = function SvgSelectLangIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SelectLangIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M10 1.667A8.336 8.336 0 0 0 1.667 10M10 1.667c4.6 0 8.333 3.733 8.333 8.333M10 1.667C12.083 3.75 13.333 7.083 13.333 10s-1.25 6.25-3.333 8.333m0-16.666C7.917 3.75 6.667 7.083 6.667 10s1.25 6.25 3.333 8.333M1.667 10c0 4.6 3.733 8.333 8.333 8.333M1.667 10h16.666M10 18.333c4.6 0 8.333-3.733 8.333-8.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SelectLangIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export { SvgSelectLangIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/SelectLangIcon.dea1044a.svg";